<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <painel-erros-comprometimentos
                    :dadosPainel="dadosPainel"
                    :servicos="obterServicos()"
                    :servicos2="obterServicos2()"
                    :permiteAcessoErroComprometimentoEtapa="
                        $temAcessoView('SGTEC-GEST-ETP-00')
                    "
                    :permiteAcessoErroComprometimentoDespesa="
                        $temAcessoView('SGTEC-GEST-DESP-01')
                    "
                    @atualizar-listagem="obterPainelErrosComprometimentos()"
                >
                </painel-erros-comprometimentos>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import GestoresServicos from '../GestoresServicos'
import EtapasServicos from '../etapas/EtapasServicos'
import PainelErrosComprometimentos from '../../componentes/paineis/PainelErrosComprometimentos'

export default {
    data() {
        return {
            tabIndex: 0,
            dadosPainel: {}
        }
    },

    methods: {
        obterPainelErrosComprometimentos() {
            this.$store.dispatch('addRequest')
            GestoresServicos.obterPainelErrosComprometimentos().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.dadosPainel = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterServicos() {
            return GestoresServicos
        },

        obterServicos2() {
            return EtapasServicos
        }
    },

    computed: {},

    created() {
        this.obterPainelErrosComprometimentos()
    },

    watch: {},

    components: {
        PainelErrosComprometimentos
    }
}
</script>
